import { apiClient } from '@/api/client';

// Loop 12: the company content an Agreement is assembled from (Edit Company Settings). The logo is the company logo
// (Settings → Company): the same /company/logo endpoints, so a change in either place changes both.
const data = (r) => r.data;
const G = '/agreements';
const form = (file) => { const fd = new FormData(); fd.append('file', file); return fd; };

// The API returns `/api/...` paths for images (a 302 to a short-lived signed URL); an <img> needs the full URL.
export const imageSrc = (path) => (path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : null);

export const getBranding = () => apiClient.get(`${G}/branding`).then(data);
export const patchBranding = (body) => apiClient.patch(`${G}/branding`, body).then(data);
export const uploadBrandingCover = (file) => apiClient.post(`${G}/branding/cover`, form(file)).then(data);
export const removeBrandingCover = () => apiClient.delete(`${G}/branding/cover`).then(data);
export const uploadCompanyLogo = (file) => apiClient.post('/company/logo', form(file)).then(data);
export const removeCompanyLogo = () => apiClient.put('/company', { logo: '' }).then(data);

export const listBlocks = () => apiClient.get(`${G}/blocks`).then(data);
export const createBlock = (body) => apiClient.post(`${G}/blocks`, body).then(data);
export const patchBlock = (id, body) => apiClient.patch(`${G}/blocks/${id}`, body).then(data);
export const deleteBlock = (id, updatedAt) => apiClient.delete(`${G}/blocks/${id}`, { params: { updated_at: updatedAt } }).then(data);

export const listAgreementTemplates = () => apiClient.get(`${G}/templates`).then(data);
// Agreements part 2: how many days an agreement holds after it's sent (1-60; 30 until set).
export const getValidDays = () => apiClient.get(`${G}/valid-days`).then(data);
export const setValidDays = (days) => apiClient.put(`${G}/valid-days`, { days }).then(data);
// Sales to cash 1: remind the client this many days before an agreement expires, at 8 AM (0 = off; 3 until set).
export const getReminderDays = () => apiClient.get(`${G}/reminder-days`).then(data);
export const setReminderDays = (days) => apiClient.put(`${G}/reminder-days`, { days }).then(data);
export const createAgreementTemplate = (name) => apiClient.post(`${G}/templates`, { name }).then(data);
export const duplicateAgreementTemplate = (id) => apiClient.post(`${G}/templates/${id}/duplicate`).then(data);
export const patchAgreementTemplate = (id, body) => apiClient.patch(`${G}/templates/${id}`, body).then(data);
export const deleteAgreementTemplate = (id, updatedAt) =>
  apiClient.delete(`${G}/templates/${id}`, { params: { updated_at: updatedAt } }).then(data);

export const listPaymentSchedules = () => apiClient.get(`${G}/payment-schedules`).then(data);
export const createPaymentSchedule = (name) => apiClient.post(`${G}/payment-schedules`, { name }).then(data);
export const patchPaymentSchedule = (id, body) => apiClient.patch(`${G}/payment-schedules/${id}`, body).then(data);
export const deletePaymentSchedule = (id, updatedAt) =>
  apiClient.delete(`${G}/payment-schedules/${id}`, { params: { updated_at: updatedAt } }).then(data);
